module.exports = __webpack_public_path__ + "static/media/ckn_restaurante_boton_accion.70288e1e.jpg";